(function () {
  function dispatchInteraction(detail) {
    document.dispatchEvent(new CustomEvent('mochila:size-guide:interaction', { detail: detail }));
  }

  function initializeCarousel(root) {
    const grid = root.querySelector('[data-size-carousel]');
    if (!grid || grid.dataset.carouselInitialized === 'true') return;

    const cards = Array.from(grid.children).filter(function (item) {
      return item.classList.contains('codex-size-guide__card');
    });
    if (cards.length < 2) return;

    grid.dataset.carouselInitialized = 'true';
    grid.setAttribute('role', 'region');
    grid.setAttribute('aria-roledescription', 'carousel');
    grid.setAttribute('aria-label', 'Bag style size comparison');

    const nav = document.createElement('div');
    nav.className = 'codex-size-guide__carousel-nav';
    nav.setAttribute('aria-label', 'Size guide carousel controls');

    const previous = document.createElement('button');
    previous.type = 'button';
    previous.className = 'codex-size-guide__carousel-arrow';
    previous.setAttribute('aria-label', 'Previous bag style');
    previous.innerHTML = '<span aria-hidden="true">←</span>';

    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'codex-size-guide__carousel-dots';

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'codex-size-guide__carousel-arrow';
    next.setAttribute('aria-label', 'Next bag style');
    next.innerHTML = '<span aria-hidden="true">→</span>';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let frame;
    let currentIndex = 0;

    const cardNames = [];
    const dots = cards.map(function (card, index) {
      const heading = card.querySelector('h3');
      const name = heading ? heading.textContent.trim() : 'Style ' + (index + 1);
      cardNames.push(name);

      if (!card.id) card.id = root.id + '-size-slide-' + (index + 1);
      card.setAttribute('role', 'group');
      card.setAttribute('aria-roledescription', 'slide');
      card.setAttribute('aria-label', (index + 1) + ' of ' + cards.length + ': ' + name);

      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'codex-size-guide__carousel-dot';
      dot.setAttribute('aria-label', 'Show ' + name);
      dot.setAttribute('aria-controls', card.id);
      dotsContainer.appendChild(dot);
      return dot;
    });

    function nearestCardIndex() {
      const gridRect = grid.getBoundingClientRect();
      const center = gridRect.left + gridRect.width / 2;
      let nearest = 0;
      let distance = Infinity;

      cards.forEach(function (card, index) {
        const rect = card.getBoundingClientRect();
        const candidate = Math.abs(rect.left + rect.width / 2 - center);
        if (candidate < distance) {
          distance = candidate;
          nearest = index;
        }
      });
      return nearest;
    }

    function updateControls() {
      frame = null;
      currentIndex = nearestCardIndex();
      dots.forEach(function (dot, index) {
        if (index === currentIndex) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      previous.disabled = currentIndex === 0;
      next.disabled = currentIndex === cards.length - 1;
    }

    function moveTo(index) {
      const targetIndex = Math.max(0, Math.min(cards.length - 1, index));
      const gridRect = grid.getBoundingClientRect();
      const cardRect = cards[targetIndex].getBoundingClientRect();
      const inset = parseFloat(window.getComputedStyle(grid).paddingLeft) || 0;

      grid.scrollTo({
        left: grid.scrollLeft + cardRect.left - gridRect.left - inset,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        moveTo(index);
        dispatchInteraction({ action: 'carousel', method: 'dot', choice: cardNames[index] });
      });
    });
    previous.addEventListener('click', function () {
      const targetIndex = Math.max(0, currentIndex - 1);
      moveTo(targetIndex);
      dispatchInteraction({ action: 'carousel', method: 'previous', choice: cardNames[targetIndex] });
    });
    next.addEventListener('click', function () {
      const targetIndex = Math.min(cards.length - 1, currentIndex + 1);
      moveTo(targetIndex);
      dispatchInteraction({ action: 'carousel', method: 'next', choice: cardNames[targetIndex] });
    });

    let userScrollStarted = false;
    let userScrollTimer;
    grid.addEventListener('touchstart', function () { userScrollStarted = true; }, { passive: true });
    grid.addEventListener('mousedown', function () { userScrollStarted = true; });
    grid.addEventListener('scroll', function () {
      if (!frame) frame = window.requestAnimationFrame(updateControls);
      if (userScrollStarted) {
        window.clearTimeout(userScrollTimer);
        userScrollTimer = window.setTimeout(function () {
          updateControls();
          dispatchInteraction({ action: 'carousel', method: 'swipe', choice: cardNames[currentIndex] });
          userScrollStarted = false;
        }, 180);
      }
    }, { passive: true });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(updateControls);
      observer.observe(grid);
    }

    nav.appendChild(previous);
    nav.appendChild(dotsContainer);
    nav.appendChild(next);
    grid.after(nav);
    updateControls();
  }

  function initializeSizeGuide(root) {
    if (!root || root.dataset.sizeGuideInitialized === 'true') return;
    root.dataset.sizeGuideInitialized = 'true';

    root.querySelectorAll('[data-size-card]').forEach(function (card) {
      const tabs = Array.from(card.querySelectorAll('[data-size-tab]'));
      const panes = Array.from(card.querySelectorAll('[data-size-pane]'));
      const cta = card.querySelector('[data-size-cta]');

      function activateTab(tab, moveFocus) {
        const targetId = tab.getAttribute('aria-controls');
        tabs.forEach(function (item) {
          const isSelected = item === tab;
          item.setAttribute('aria-selected', String(isSelected));
          item.tabIndex = isSelected ? 0 : -1;
        });
        panes.forEach(function (pane) {
          pane.hidden = pane.id !== targetId;
        });
        if (cta) {
          const isAvailable = tab.dataset.available !== 'false';
          cta.href = isAvailable ? tab.dataset.url : tab.dataset.fallbackUrl;
          cta.textContent = isAvailable ? tab.dataset.label : tab.dataset.fallbackLabel;
          cta.classList.toggle('is-unavailable', !isAvailable);
        }
        if (moveFocus) tab.focus();
      }

      tabs.forEach(function (tab, index) {
        const pane = card.querySelector('#' + CSS.escape(tab.getAttribute('aria-controls')));
        if (!tab.id) tab.id = tab.getAttribute('aria-controls') + '-tab';
        if (pane) pane.setAttribute('aria-labelledby', tab.id);
        tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1;

        tab.addEventListener('click', function () {
          activateTab(tab, false);
          dispatchInteraction({
            action: 'tab',
            method: 'click',
            choice: tab.textContent.trim(),
            available: tab.dataset.available || 'unknown'
          });
        });

        tab.addEventListener('keydown', function (event) {
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = tabs.length - 1;
          else return;

          event.preventDefault();
          activateTab(tabs[nextIndex], true);
          dispatchInteraction({
            action: 'tab',
            method: 'keyboard',
            choice: tabs[nextIndex].textContent.trim(),
            available: tabs[nextIndex].dataset.available || 'unknown'
          });
        });
      });
    });

    root.addEventListener('click', function (event) {
      const cta = event.target.closest('.codex-size-guide__button');
      if (!cta || !root.contains(cta)) return;
      dispatchInteraction({
        action: 'cta',
        method: 'click',
        choice: cta.textContent.trim(),
        available: cta.classList.contains('is-unavailable') ? 'false' : 'true'
      });
    });

    initializeCarousel(root);
  }

  function initializeAll(scope) {
    (scope || document).querySelectorAll('[data-codex-size-guide]').forEach(initializeSizeGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
